import { Component, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { AuthService, ScrollService } from '../../api/';
import { ToastyService, ToastyConfig, ToastOptions } from 'ng2-toasty';

@Component({
  selector: 'app-request-password-reset',
  templateUrl: './request-password-reset.component.html',
  styleUrls: ['./request-password-reset.component.css']
})
export class RequestPasswordResetComponent implements AfterViewInit {
  public screenname: string = '';
  public email: string = '';
  private errorArray: Array<any> = [];
  private loading: boolean = false;
  private submitted: boolean = false;

  constructor(private authService: AuthService, private toastyService: ToastyService, private toastyConfig: ToastyConfig,
    private scrollService: ScrollService, private router: Router, private route: ActivatedRoute) {
    this.toastyConfig.theme = 'material';
    if (this.route.snapshot.data['done'] === true) {
      this.submitted = true;
      this.route.queryParams.subscribe(
          params => {
              this.email = params['email'] || '';
          });

    }
  }
    trimSpaces() {
        this.screenname = this.screenname.replace(/\s+/g, '_');
        this.screenname = this.screenname.replace(/_{2,}/g, '_');
        this.screenname = this.screenname.replace(/-{2,}/g, '-');
    }
  ngAfterViewInit() {
    if (this.authService.isUserLoggedIn() === true) {
      this.router.navigate(['/']);
    }
    this.scrollService.toggleProgressBar(false);
  }

  sendPasswordResetRequest() {
    this.loading = true;
    this.scrollService.toggleProgressBar(true);
    this.authService.sendPasswordResetRequest(this.screenname).subscribe((res) => {
      let data = res.json();
      let toastOptions: ToastOptions = {
        title: 'Request Sent.',
        msg: data.msg,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };

      this.loading = false;
      this.screenname = '';
      this.router.navigate(['/request-password-reset/mail-sent'], { queryParams: { email: data.email } });
    }, (err) => {
      this.handleErrors(err);
      this.loading = false;
    });
  }

  handleErrors(err: any) {
    this.errorArray = [];
    let validationErrors = JSON.parse(err._body);
    if (err._body) {
      for (let index = 0; index < validationErrors.length; index++) {
        this.errorArray[validationErrors[index].field] = validationErrors[index].message;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/user/request-password-reset/request-password-reset.component.ts